import styled from 'styled-components';
import Icon from '../../../_shared/components/Icon';
import Button from '../../../_shared/components/Button';

export const RemoveDocumentButton = styled(Button.Transparent)`
  padding: 0;
  flex-basis: 10%;
`;

export const RemoveDocumentIcon = styled(Icon).attrs({
  icon: 'TR5-Trashcan'
})`
  height: 18px;
  width: 18px;
  fill: ${({ theme }) => theme.COLORS.INFO};
  margin-right: 10px;
  color: black;
`;

export const FilePreviewLink = styled.a`
  flex-basis: 80%;
  padding: 0;
  margin: 0;
  align-self: flex-start;
  text-align: left;
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  &:hover {
    color: ${({ theme }) => theme.COLORS.TERTIARY};
  }
`;

export const FilePreviewSeparator = styled.span`
  margin-left: 70%;
`;

export const PreviewUploadedDocsDiv = styled.div`
  padding-top: 30px;
`;

export const ProgressBar = styled.div`
  height: 5px;
  margin-top: 7px;
  background-color: ${({ theme }) => theme.COLORS.FADED_BLUE};
  width: 100%;
  overflow: hidden;
`;

export const ProgressBarValue = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.COLORS.CRISP_BLUE};
  animation: indeterminateAnimation 1s infinite linear;
  transform-origin: 0 50%;
  @keyframes indeterminateAnimation {
    0% {
      transform: translateX(0) scaleX(0);
    }
    40% {
      transform: translateX(0) scaleX(0.4);
    }
    100% {
      transform: translateX(100%) scaleX(0.5);
    }
  }
`;

export const SuccessUploadIcon = styled(Icon).attrs(({ theme }) => ({
  icon: 'TR5-Toggle_check',
  color: theme.COLORS.BRAND
}))`
  height: 22px;
  width: 22px;
  margin-right: 10px;
  margin-left: -5px;
  flex-basis: 10%;
`;

export const SuccessUploadIconAnimate = styled(SuccessUploadIcon)`
  animation: pulse 1s;
  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
      opacity: 25%;
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
      opacity: 50%;
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      opacity: 25%;
    }
  }
`;
